module.exports = __webpack_public_path__ + "img/awards11.cffe2970.svg";